export default function(user) {
    let result = `${user.last_name} ${user.name[0]}.`;
    if (user.patronymic) {
        result += `${user.patronymic[0]}.`;
    }

    return result;
}
